import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT } from "../data";

const links = [
  { label: "Services", id: "services" },
  { label: "Approach", id: "approach" },
  { label: "Work", id: "work" },
  { label: "Reviews", id: "reviews" },
  { label: "Quote", id: "quote" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-bone/95 backdrop-blur-md border-b border-stone" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex items-center justify-between h-20 md:h-28">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center group"
          aria-label="Exterior Nature Care — home"
        >
          <img
            src="/logo.png"
            alt="Exterior Nature Care"
            className="h-16 md:h-24 w-auto transition-transform duration-300 group-hover:scale-[1.04]"
          />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-sm font-medium tracking-tight relative group ${scrolled ? "text-pine" : "text-bone"}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[1.5px] w-0 bg-terra transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-phone"
            className={`hidden sm:flex items-center gap-2 text-sm font-semibold ${scrolled ? "text-pine" : "text-bone"}`}
          >
            <Phone size={15} className="text-terra" strokeWidth={2.5} />
            {CONTACT.phone}
          </a>
          <button
            data-testid="nav-quote-cta"
            onClick={() => go("quote")}
            className="btn-wipe hidden sm:inline-flex items-center bg-terra text-bone text-sm font-bold px-5 py-2.5 tracking-tight"
          >
            Get a Quote
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className={`md:hidden ${scrolled ? "text-pine" : "text-bone"}`}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-pine border-t border-white/10">
          <div className="px-5 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-bone text-2xl font-display font-bold text-left"
              >
                {l.label}
              </button>
            ))}
            <a href={CONTACT.phoneHref} className="text-terra font-bold text-lg mt-2">{CONTACT.phone}</a>
          </div>
        </div>
      )}
    </header>
  );
};
